import DefaultSlideAppearance from '@redturtle/volto-io-studio/components/Blocks/Listing/Carousel/DefaultSlideAppearance';
import { GridBlockSchema } from '@plone/volto/components/manage/Blocks/Grid/schema';
import FacultyBlockSchema from '@redturtle/volto-io-studio/components/Blocks/Faculty/schema.js';
import GridTemplates from '@redturtle/volto-io-studio/components/Blocks/Grid/templates';
import CardWithStripBlockTemplate from '@redturtle/volto-io-studio/components/Blocks/Listing/CardWithStrip/CardWithStripBlockTemplate';
import CardsTemplate from '@redturtle/volto-io-studio/components/Blocks/Listing/CardsTemplate/CardsTemplate';
import applyListingCarouselConfig from '@redturtle/volto-io-studio/config/Blocks/listingCarouselConfig';
import heroSVG from '@plone/volto/icons/hero.svg';
import bookSVG from '@plone/volto/icons/book.svg';
import alignJustifySVG from '@plone/volto/icons/align-justify.svg';
import alertSVG from '@plone/volto/icons/alert.svg';
import perssonSVG from '@plone/volto/icons/user.svg';
import reviewsSVG from '@redturtle/volto-io-studio/icons/reviews.svg';

import {
  AlertBlockEdit,
  AlertBlockView,
  HeroImageLeftView,
  HeroImageLeftEdit,
  FacultyView,
  FacultyEdit,
  TitleBlockView,
  TitleBlockEdit,
  CorsiBlockEdit,
  CorsiBlockView,
  GridColumnBlocksFormEdit,
  GridColumnBlocksFormView,
  ReviewsBlockEdit,
  ReviewsBlockView,
  ReviewsBlockSchema,
  TableBlockEdit,
  TableBlockView,
  TeachingsView,
  TeachingsEdit,
  ListingLinkMore,
} from '@redturtle/volto-io-studio/components/Blocks';

import {
  AccordionSchema,
  NumbersSchema,
} from '@redturtle/volto-rt-blocks/components/Blocks';
import { composeSchema } from '@plone/volto/helpers';

const applyIOStudioBlocksConfig = (config) => {
  const customBlocksOrder = [
    { id: 'homePage', title: 'Home Page' },
    { id: 'university', title: 'University' },
  ];
  const slateSchemaEnhancer = config.blocks.blocksConfig.slate.schemaEnhancer;
  const tabsSchema = config?.blocks?.blocksConfig?.tabs?.schema;

  config.settings['volto-rt-carousel'].slide_appearances.default.component =
    DefaultSlideAppearance;

  config.blocks = {
    ...config.blocks,
    groupBlocksOrder: config.blocks.groupBlocksOrder.concat(customBlocksOrder),
  };

  config.blocks.blocksConfig = {
    ...config.blocks.blocksConfig,

    title: {
      ...config.blocks.blocksConfig.title,
      edit: TitleBlockEdit,
      view: TitleBlockView,
      sidebarTab: 0,
    },

    listing: {
      ...config.blocks.blocksConfig.listing,
      //getAsyncData: null, // questo disabilita il ssr dei listing perché rallenta vistosamente la pagina
      showLinkMore: true,
      variations: [
        ...config.blocks.blocksConfig.listing.variations,
        {
          id: 'strip',
          isDefault: true,
          title: 'Fascia',
          template: CardWithStripBlockTemplate,
        },
        {
          id: 'cardsTemplate',
          isDefault: true,
          title: 'Schede a Griglia',
          template: CardsTemplate,
        },
      ],
      link_more: { component: ListingLinkMore },
    },

    alertBlock: {
      id: 'alertBlock',
      title: 'Alert',
      icon: alertSVG,
      group: 'text',
      view: AlertBlockView,
      edit: AlertBlockEdit,
      restricted: false,
      mostUsed: false,
      security: {
        addPermission: [],
        view: [],
      },
      sidebarTab: 1,
    },

    hero: {
      id: 'hero',
      title: 'Hero',
      icon: heroSVG,
      group: 'common',
      view: HeroImageLeftView,
      edit: HeroImageLeftEdit,
      restricted: false,
      mostUsed: false,
      sidebarTab: 1,
      blockHasOwnFocusManagement: true,
    },

    numbers: {
      ...config.blocks.blocksConfig.numbers,
      schema: (props) => {
        let schema = NumbersSchema(props);
        schema.properties.bg.choices = [
          ['none', 'Nessuno'],
          ['subsite-primary', 'Di accento'],
        ];
        return schema;
      },
    },

    // TODO: restricted: true (?) - check if it's needed
    facultyBlock: {
      id: 'facultyBlock',
      title: 'Professori',
      icon: perssonSVG,
      group: 'university',
      view: FacultyView,
      edit: FacultyEdit,
      restricted: false,
      schema: FacultyBlockSchema,
      mostUsed: false,
      security: {
        addPermission: [],
        view: [],
      },
      sidebarTab: 1,
    },

    // TODO: restricted: true (?) - check if it's needed
    // TODO: security - check if it's needed/implemented
    teachingsBlock: {
      id: 'teachingsBlock',
      title: 'Insegnamenti',
      icon: bookSVG,
      group: 'university',
      view: TeachingsView,
      edit: TeachingsEdit,
      restricted: false,
      mostUsed: false,
      security: {
        addPermission: [],
        view: [],
      },
      sidebarTab: 1,
    },

    accordion: {
      ...config.blocks.blocksConfig.accordion,
      schema: (props) => {
        let schema = AccordionSchema(props);
        schema.properties.styles.schema.properties.bg.colors = [
          { name: 'transparent', label: 'Nessuno' },
          { name: 'subsite-primary', label: 'Di accento' },
        ];
        return schema;
      },
    },

    corsiBlock: {
      id: 'corsiBlock',
      title: 'Info Corsi',
      icon: bookSVG,
      group: 'homePage',
      view: CorsiBlockView,
      edit: CorsiBlockEdit,
      restricted: false,
      mostUsed: false,
      security: {
        addPermission: [],
        view: [],
      },
      sidebarTab: 0,
    },
    reviewsBlock: {
      id: 'reviewsBlock',
      title: 'Testimonianze',
      icon: reviewsSVG,
      group: 'common',
      view: ReviewsBlockView,
      edit: ReviewsBlockEdit,
      restricted: false,
      mostUsed: false,
      security: {
        addPermission: [],
        view: [],
      },
      sidebarTab: 1,
      blockSchema: ReviewsBlockSchema,
    },
    slateTable: {
      ...config.blocks.blocksConfig.slateTable,
      edit: TableBlockEdit,
      view: TableBlockView,
    },

    slate: {
      ...config.blocks.blocksConfig.slate,
      schemaEnhancer: composeSchema(
        slateSchemaEnhancer,
        ({ schema, formData, intl }) => {
          schema.properties.styles.schema.properties.bg.colors.push({
            name: 'subsite-primary',
            label: 'Di accento',
          });
          return schema;
        },
      ),
    },

    tabs: {
      ...config.blocks.blocksConfig.tabs,
      schema: composeSchema(tabsSchema, ({ schema, formData, intl }) => {
        schema.properties.styles.schema.properties.bg.colors.push({
          name: 'subsite-primary-light',
          label: 'Di accento chiaro',
        });
        schema.properties.bg_title.colors.push(
          { name: 'subsite-primary', label: 'Di accento' },
          { name: 'primary', label: 'Primario' },
        );
        schema.properties.bg_title.default = 'subsite-primary';
        return schema;
      }),
    },
  };

  config.blocks.blocksConfig.gridBlock = {
    ...config.blocks.blocksConfig.gridBlock,
    templates: GridTemplates,
    maxLength: 6,
    blockSchema: (props) => {
      //const { intl } = props;
      let schema = GridBlockSchema(props);
      schema.fieldsets[0].fields.push('styles');

      schema.properties.styles = {
        widget: 'object',
        schema: {
          title: 'Stile',
          fieldsets: [
            {
              id: 'default',
              fields: ['bg', 'full-width:bool'],
              title: 'Default',
            },
          ],
          properties: {
            bg: {
              title: 'Colore di sfondo',
              default: 'none',
              choices: [
                ['none', 'Nessuno'],
                ['primary', 'Primario'],
                ['subsite-primary', 'Di accento'],
                ['subsite-primary-image', 'Di accento con immagine'],
                ['subsite-primary-light', 'Di accento chiaro'],
                ['light-gray', 'Grigio chiaro'],
              ],
            },
            'full-width:bool': {
              title: 'A tutta larghezza',
              type: 'boolean',
            },
          },
          required: [],
        },
      };
      return schema;
    },
    allowedBlocks: [
      ...config.blocks.blocksConfig.gridBlock.allowedBlocks,
      'gridColumnBlocksForm',
      'repeatableContentBlock',
      'accordion',
    ],
    blocksConfig: {
      ...config.blocks.blocksConfig,
      repeatableContentBlock: config.blocks.blocksConfig.repeatableContentBlock,
      gridColumnBlocksForm: {
        id: 'gridColumnBlocksForm',
        title: 'Blocchi',
        icon: alignJustifySVG,
        group: 'common',
        view: GridColumnBlocksFormView,
        edit: GridColumnBlocksFormEdit,
        restricted: false,
        mostUsed: true,
        security: {
          addPermission: [],
          view: [],
        },
        sidebarTab: 0,
      },
    },
  };

  applyListingCarouselConfig(config);
  //remove volto's unused blocks
  delete config.blocks.blocksConfig.leadimage;
};
export default applyIOStudioBlocksConfig;
